<template>
  <div>
    <div class="ipv4">
      <el-input
        :id="idPrefix + startIndex + idSuffix"
        ref="ip1"
        v-model="ip1"
        size="small"
        maxlength="3"
        :disabled="disabled || disabledInput(1)"
        @keyup.native="inputLimit(1, $event)"
        @mouseup.native="inputLimit(1, null)"
        @input="inputLimit(1, null)"
      />
      <span class="dot" :class="disabled && 'disabled'">.</span>
      <el-input
        :id="idPrefix + (startIndex + 1) + idSuffix"
        ref="ip2"
        v-model="ip2"
        size="small"
        maxlength="3"
        :disabled="disabled || disabledInput(2)"
        @keyup.native="inputLimit(2, $event)"
        @mouseup.native="inputLimit(2, null)"
        @input="inputLimit(2, null)"
      />
      <span class="dot" :class="disabled && 'disabled'">.</span>
      <el-input
        :id="idPrefix + (startIndex + 2) + idSuffix"
        ref="ip3"
        v-model="ip3"
        size="small"
        maxlength="3"
        :disabled="disabled || disabledInput(3)"
        @keyup.native="inputLimit(3, $event)"
        @mouseup.native="inputLimit(3, null)"
        @input="inputLimit(3, null)"
      />
      <span class="dot" :class="disabled && 'disabled'">.</span>
      <el-input
        :id="idPrefix + (startIndex + 3) + idSuffix"
        ref="ip4"
        v-model="ip4"
        size="small"
        maxlength="3"
        :disabled="disabled || disabledInput(4)"
        @keyup.native="inputLimit(4, $event)"
        @mouseup.native="inputLimit(4, null)"
        @input="inputLimit(4, null)"
      />
    </div>
  </div>
</template>
<script>
import { logWithPrefix } from "@/plugins/logging";
const log = logWithPrefix("[components/elements/ipAddress.vue]");
export default {
  props: {
    idPrefix: {
      type: String,
      default: "ipv4",
    },
    idSuffix: {
      type: String,
      default: "",
    },
    startIndex: {
      type: Number,
      default: 1,
    },
    config: {
      type: String,
      default: "",
    },
    limit: {
      type: String,
      default: "",
    },
    defaultValue: {
      type: String,
      default: "...",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ip1: "",
      ip2: "",
      ip3: "",
      ip4: "",
    };
  },
  watch: {
    config: {
      handler() {
        if (this.config) {
          const arr = this.config.split(".");
          if (arr.length || this.config == "...") {
            this.ip1 = arr[0] || "";
            this.ip2 = arr[1] || "";
            this.ip3 = arr[2] || "";
            this.ip4 = arr[3] || "";
          } else {
            const defaultArr = this.defaultValue.split(".");
            this.ip1 = defaultArr[0] || "";
            this.ip2 = defaultArr[1] || "";
            this.ip3 = defaultArr[2] || "";
            this.ip4 = defaultArr[3] || "";
          }
        } else if (this.disableNum > 0) {
          const defaultArr = this.defaultValue.split(".");
          this.ip1 = defaultArr[0] || "";
          this.ip2 = defaultArr[1] || "";
          this.ip3 = defaultArr[2] || "";
          this.ip4 = defaultArr[3] || "";
        } else {
          this.ip1 = "";
          this.ip2 = "";
          this.ip3 = "";
          this.ip4 = "";
        }
      },
      immediate: true,
    },
  },
  methods: {
    disabledInput(index) {
      return this.disableNum >= index;
    },
    change() {
      const ip = [this.ip1, this.ip2, this.ip3, this.ip4].join(".");
      this.$emit("update:config", ip === "..." ? "" : ip);
      this.$emit("change");
    },

    inputLimit(idx, event) {
      log(event);
      const nexRefName = "ip" + (idx + 1);
      let val = this["ip" + idx];
      let lastChar = "";
      if (event) {
        lastChar = event.key;
      } else if (val.length) {
        lastChar = val[val.length - 1];
      }
      log(idx, "lastChar: " + lastChar);
      this["ip" + idx] = this["ip" + idx].replace(/\D+/, "");

      if (idx !== 4) {
        if (event && lastChar === "." && this["ip" + idx] !== "") {
          log("ip" + (idx + 1), this.$refs["ip" + (idx + 1)]);
          this.$refs[nexRefName].select();
          this.$refs[nexRefName].focus();
        } else if (event && lastChar != "Tab" && this["ip" + idx].length == 3) {
          this.$refs[nexRefName].select();
          this.$refs[nexRefName].focus();
        }
      }

      const reg = /^(([0-9])|([1-9][0-9])|(1[0-9][0-9])|(2[0-4][0-9])|(25[0-5]))$/;
      val = this["ip" + idx];
      if (!reg.test(val)) {
        const match = val.match(/((25[0-5])|(2[0-4][0-9])|(1[0-9][0-9])|([1-9][0-9])|([0-9]))/);
        if (match) {
          this["ip" + idx] = match[0];
        } else {
          this["ip" + idx] = "";
        }
      }
      this.change();
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.ipv4 {
  .el-input {
    width: $formInputFontSize * 0.65 * 3 + $formInputPaddingLeftRight !important;
  }
  .disabled {
    color: $formGrayOutColor;
  }
  .dot {
    margin-right: 4px;
  }
}
.orbi.gui-2-1 {
  .ipv4 {
    .el-input {
      width: 58px !important;
    }
  }
}
</style>
